import React from 'react';
import ContractItem from './ContractItem';

function ContractList({ timesheets, onSelect, selectedId }) {
    return (
        <div className="timesheet-list">
            {timesheets.map((item) => (
                <ContractItem
                    key={item.id}
                    timesheet={item}
                    isSelected={item.id === selectedId}
                    onClick={() => onSelect(item)}
                />
            ))}
        </div>
    );
}

export default ContractList;
